<template>
  <div id="Tunnel">
    <bg-video ref="bv" :class="{ blur }" :filename="filename" autoplay loop :muted="true"/>
    <logo/>
    <img v-show="QRVisiable" class="qr pos-c" src="./img/game.png" alt="">
    <guide-button class="btn-lt" @click.native="next(step - 1)">返回</guide-button>
    <guide-button class="btn-rt" @click.native="handleNarrateEnded">继续</guide-button>
    <guide-button v-show="QRVisiable" class="btn-rt" @click.native="next(3)">继续</guide-button>
  </div>
</template>

<script>
import logo from '../Logo'

export default {
  name: 'Tunnel',
  components: {
    logo,
  },
  data () {
    return {
      blur: false,
      QRVisiable: false,
      step: this.$route.meta.back ? 3 : (this.$route.query.step || 0),
      fnList: [
        () => this.playNarrate('08', { btnText: '世界最重沉管的建造' }).then(_ => this.$vplayer.play({ url: 'zzcg' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('09', { btnText: '沉管的浮运与安装' }).then(_ => this.$vplayer.play({ url: 'fyaz' })).then(() => this.next(this.step + 1)),
        () => this.playNarrate('10', { auto: true })
          .then(_ => {
            this.blur = true
            this.$refs.bv.pause()
            this.QRVisiable = true
          }),
        () => this.playNarrate('11', { btnText: '港珠澳大桥主体桥梁工程建设' }).then(_ => {
          this.$router.push('/Part01/Bridge')
        }),
      ],
    }
  },
  computed: {
    filename () {
      return `Tunnel-${this.step}`
    },
  },
  mounted () {
    this.next(this.step)
  },
  methods: {
    next (step) {
      this.$vplayer.clear()
      if (step < 0) {
        this.$router.push('/Part01/Island')
      }
      this.blur = false
      this.$refs.bv.play()
      this.step = step
      this.QRVisiable = false
      this.fnList[step]()
    },
    playNarrate (filename, opts) {
      this.blur = false
      this.$refs.bv.play()
      return this.$narrate.play(filename, { ...opts, onended: this.handleNarrateEnded })
    },
    handleNarrateEnded () {
      this.$narrate.skip()
      this.$refs.bv.pause()
      this.blur = true
    },
  },
}
</script>

<style lang="scss" scoped>
.qr {
  width: 13.9rem;
  height: 6.2rem;
}
</style>
